import { Center } from '@starryui10/layouts/Center';
import { VStack } from '@starryui10/layouts/Stack';
import { Text } from '@starryui10/typography/Text';
import * as React from 'react';
import { MoonLoader } from 'react-spinners';
import styled from 'styled-components';
import { color as colour } from '../theme/color';

interface IPageLoaderProps {
    caption: string;
    color?: string;
    size?: number;
}

export const PageLoader: React.FC<IPageLoaderProps> = ({ caption, color = colour.Blue.B60, size = 60 }) => {
    return (
        <PageLoaderWrapper>
            <VStack gap="medium">
                <MoonLoader color={color} size={size} />
                {caption && (
                    <Center>
                        <Text>{caption}</Text>
                    </Center>
                )}
            </VStack>
        </PageLoaderWrapper>
    );
};

const PageLoaderWrapper = styled.div`
    top: 40%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: 200px;
    height: 120px;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    box-sizing: content-box;
`;
